import * as CONST from '@/constants'
const defaultConfig = {
  text: '',
  sub_text: '',
  status: undefined,
  static: false,
  redirect_to: undefined,  
  centerAligned: true,  
  hideHeader: true,  
  hideFooter: true,
  hideBackdrop: false,
  custom_icon: undefined,  
  web_theme: false,  
  cancel_button: {
    label: 'Cancel',
    callback: undefined,
  },  
  ok_button: {
    label: 'OK',
    callback: undefined,
  },  
}

export default {
  state: {
    is_notification_shown: false,
    notification_timer_id: undefined,
    notification_config: defaultConfig,
  },
  mutations: {
    SHOW: state => {
      state.is_notification_shown = true
    },
    HIDE: state => {
      state.is_notification_shown = false
    },
    SET_TIMER_ID: (state, timer_id) => {
      state.notification_timer_id = timer_id
    },
    SET_NOTIFICATION_CONFIG: (state, data) => {
      state.notification_config = data
    },
  },
  actions: {
    showNotification({ commit, state }, data) {
      if (state.notification_timer_id) {
        clearTimeout(state.notification_timer_id)
      }
      commit('SET_TIMER_ID', undefined)
      let newConfig = state.notification_config
      for (var i in data) {
        newConfig[i] = data[i]
      }
      commit('SET_NOTIFICATION_CONFIG', newConfig)
      commit('SHOW')

      if (!data.static) {
        var timer_id = setTimeout(function() {
          commit('HIDE')
          commit('SET_TIMER_ID', undefined)
        }, CONST.NOTIFICATION_DURATION)
        commit('SET_TIMER_ID', timer_id)
      }
    },
    hideNotification({ commit, state }) {
      if (state.notification_timer_id) {
        clearTimeout(state.notification_timer_id)
      }
      commit('SET_TIMER_ID', undefined)
      commit('HIDE')
      commit('SET_NOTIFICATION_CONFIG', defaultConfig)
    },
  },
  getters: {
    notification_config: state => state.notification_config,
    is_notification_shown: state => state.is_notification_shown,
  },
}
